// ScrollToHash.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior: "smooth" 
          });
        }, 100); // slight delay for DOM readiness
      }
    }
  }, [hash]);

  return null;
};

export default ScrollToHash;
